import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import { fetchData, fetchFormData } from "../../utils/options";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const Loan_Inquiry_StatusCreate = ({ permission }) => {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    Swal.fire({
      title: "loading...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // Close the loader after a short delay
    const timer = setTimeout(() => {
      Swal.close();
    }, 600);

    return () => clearTimeout(timer);
  }, [permission, id]);

  const fetchDetails = async () => {
    try {
      const formData = new FormData();
      formData.append("id", id); // Send ID in the form data

      const result = await fetchFormData(
        "get-by-id-loan-inquiry-statuses",
        formData,
        "POST"
      );

      if (result && result.data) {
        setRole(result.data.loan_inquiry_status);
      } else {
        console.warn("Bank data not found.");
        setRole("");
      }
    } catch (error) {
      console.error("Failed to fetch bank details:", error);
      setRole("");
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("loan_inquiry_status", role);
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    try {
      let res;

      if (id) {
        formData.append("id", id);
        formData.append("userId", userId);
        // Edit logic - update
        res = await fetchFormData(
          "update-loan-inquiry-statuses",
          formData,
          "POST"
        );
        console.log("Updating loan-inquiry-status:", id, formData);
      } else {
        // Create logic - new
        res = await fetchFormData("add-loan-inquiry-status", formData, "POST");
        console.log("Creating new loan-inquiry-status:", formData);
      }
      console.log(res);
      if (res && (res.code === 200 || res.code === 201)) {
        topTost({
          title: res.message,
          icon: "success",
        });
        navigate(`/master/inquiry-status-list?id=${M_id}`);
      } else if (res && res.code === 422) {
        topTost({
          title: Array.isArray(res.message)
            ? res.message[0]
            : res.message || "Validation error",
          icon: "error",
        });
      } else {
        console.error("operation failed", res);
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            {permission?.pf_add === 1 || id ? (
              <>
                <div className="mb-5 d-flex align-items-center justify-content-between">
                  <h5 className="fw-bold mb-0 me-4">
                    <span className="d-block mb-2">
                      {id ? "Edit Inquiry Status:" : "Add Inquiry Status:"}
                    </span>
                  </h5>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        icon="feather-briefcase"
                        label="Inquiry Status"
                        labelId="roleInput"
                        placeholder="Inquiry Status"
                        name="Inquiry_Status"
                        value={role}
                        required
                        onChange={(name, value) => setRole(value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary"
                        disabled={isSubmitting}
                      >
                        {isSubmitting
                          ? "Submitting..."
                          : id
                          ? "Update"
                          : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              </>
            ) : (
              <div className="alert alert-#283c50; text-center">
                <h5></h5>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Loan_Inquiry_StatusCreate;
